import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Poster from "../components/Poster";

const IndexPage = ({ wordId, quoteId, imgId, path, ...props }) => {
  return (
    <Layout>
      <SEO title="Home" />
      <Poster />
    </Layout>
  );
};

export default IndexPage;
